import React, { useState, useEffect } from 'react';
import Section from '../Section';
import AnimatedIcon from '../AnimatedIcon';

// utils
import { debounce } from '/lib/reactutils/utils'

interface OurSolutionsProps {
    componentPath: string;
    title?: string;
    text?: string;
    animatedIconPaths?: {name: string, path: string, href: string}[];
}

export default function OurSolutions({
    componentPath,
    title,
    text,
    animatedIconPaths = [
        {
            name: 'ATC',
            path: '/svg/Jotron-Icon-ATC.json',
            href: '/'
        },
        {
            name: 'Coastal',
            path: '/svg/Jotron-Icon-Coastal.json',
            href: '/'
        },
        {
            name: 'Energy',
            path: '/svg/Jotron-Icon-Energy.json',
            href: '/'
        },
        {
            name: 'Maritime',
            path: '/svg/Jotron-Icon-Maritime.json',
            href: '/'
        }
    ]
}: OurSolutionsProps) {
    
    useEffect(() => {
        document.dispatchEvent(new CustomEvent('ourSolutionsLoaded', { detail: { componentId: componentPath } }))
    }, [])

    /*
    useEffect(() => {
        const handleScroll = () => {
            
            const mainElement = document.querySelector('main#main')

            // check if main#main has the class .frontpage-page
            if (!mainElement || !mainElement.classList.contains('frontpage-page')) {
                return
            }
    
            const section = document.getElementById('our-solutions-section')

            if (!section) return
    
            const rect = section.getBoundingClientRect()
            const snapRange = 350 // range in pixels from the top of the viewport
    
            if (rect.top >= -snapRange && rect.top <= snapRange) {
                section.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                })
            }
        }
    
        // Wrap the scroll handler with debounce
        const debouncedHandleScroll = debounce(handleScroll, 20)
    
        window.addEventListener('scroll', debouncedHandleScroll)
    
        return () => {
            window.removeEventListener('scroll', debouncedHandleScroll)
        }
    }, [])
    */

    return (
        <Section id={componentPath} bgColor="bg-primary" textColor="text-light">
            <div className="grid-container our-solutions" id='our-solutions-section'>
                <div className="grid-row our-solutions__wrapper">
                    <div className="c-12 start-md-4 c-md-6 our-solutions__header">
                        <h2 className="our-solutions__title">{title}</h2>
                        <p className="our-solutions__text">{text}</p>
                    </div>
                    <div className="c-12 our-solutions__solutions-wrapper">
                        {animatedIconPaths.map((icon, i) => (
                            <AnimatedIcon key={i} href={icon.href} animationPath={icon.path} label={icon.name} />
                        ))}
                    </div>
                </div>
            </div>
        </Section>
    );
}
